export const LOGIN = 'login';
export const PRODUCT = 'product';
export const PRODUCT_GROUP = 'group';
export const IMAGES = 'images';
export const TAG = 'tag';
export const TAX_GROUP = 'tax_group';
export const INGREDIENT = 'ingredient';
export const QUIZ = 'quiz';
export const ANSWER = 'answer';
export const RECIPE_OVERRIDE = 'recipe_override';
export const ORDERS = 'orders';
export const ALLERGEN = 'allergen';
export const MENU = 'menu';
export const RECIPE = 'recipe';
